export default class StoqCustom {

    static getButton() {
        return document.getElementById('notify-me-btn');
    }

    static getRules() {
        const rules = document.getElementById('notify-me-rules');
        return JSON.parse(rules?.textContent);
    }

    /**
   * Handle button visibility
   *
   * @param {HTMLElement} selectedOption
   */
    static variantChanged(selectedOption) {
        const rules = this.getRules();
        const rule = rules.find(v => v.id === selectedOption.dataset.variantId);

        // this even triggers immediately when switching products, so the rules object won't be updated for the new product yet, leading to an undefined rule
        // so we can bail here because we only want to watch for variant changes for the same product
        if (!rule) {
            return;
        }

        const button = this.getButton();
        if (!button) {
            return;
        }

        if (rule.parentHidden) {
            button.style.display = 'none';
            return;
        }

        if (rule.variantHidden) {
            button.style.display = 'none';
            return;
        }

        button.style.display = selectedOption.dataset.optionAvailable === 'true' ? 'none' : '';
    }

    static buttonInit() {
        const button = this.getButton();
        if (!button) {
            return;
        }
        button.addEventListener('click', (e) => {
            e.preventDefault();
            if (typeof window._RestockRocket === 'undefined') {
                button.textContent = "There was an error, please try again"
                return;
            } else {
                button.textContent = "Join Waitlist"
            }
            window._RestockRocket.openModal(
                {
                    id: button.dataset.productId,
                    variants: JSON.parse(button.dataset.variants),
                },
                button.dataset.variantId
            );
        });
    }
}
